export default __webpack_public_path__ + "static/media/image30.62e7cfc9.jpg";